export const tests = {
    route: '测试',
    smartPiTests: '智能派'
};
